import React from 'react';
import { getStepComponent } from './steps';

interface BreadcrumbStep {
  id: string;
  title: string;
  description: string;
}

interface ProfileStepProps {
  step: BreadcrumbStep;
  stepIndex: number;
  userType: 'startup' | 'investor';
  onComplete: () => void;
  onCreateProfile?: (formData: any) => void;
  hasProfile?: boolean;
  shouldValidate?: boolean;
  onValidationHandled?: () => void;
  onValidationResult?: (passed: boolean, latestFormData?: any) => void;
}

const ProfileStep: React.FC<ProfileStepProps> = ({
  step,
  userType,
  onComplete,
  onCreateProfile,
  hasProfile,
  shouldValidate,
  onValidationHandled,
  onValidationResult,
}) => {
  const renderStepContent = () => {
    const StepComponent = getStepComponent(step.id, userType);

    if (StepComponent) {
      return (
        <StepComponent
          userType={userType}
          onCreateProfile={onCreateProfile}
          hasProfile={hasProfile}
          onComplete={onComplete}
          shouldValidate={shouldValidate}
          onValidationHandled={onValidationHandled}
          onValidationResult={onValidationResult}
        />
      );
    }

    // Fallback for steps not yet implemented
    return (
      <div className="space-y-6">
        <div className="text-center py-12">
          <h3 className="text-xl font-semibold text-gray-700 mb-4">{step.title}</h3>
          <p className="text-gray-500">Step form coming soon...</p>
        </div>
      </div>
    );
  };

  return (
    <div className="flex justify-center">
      <div className="w-1/2 bg-dark-950 p-8">{renderStepContent()}</div>
    </div>
  );
};

export default ProfileStep;
